import { Option } from 'components/elements/FloatingToolbar/types'

import Link from 'components/elements/Link'
import CustomIcon from 'components/elements/CustomIcon'
import Icon from 'components/elements/Icon'

import styles from './gridItem.module.scss'

const FloatingToolbarGridOption = ({
  icon,
  label,
  disabled,
  customIcon,
  iconElement,
  onClick,
  to,
  target,
  className = '',
}: Option) => {
  const base = (
    <button className={`${styles.option} ${className}`} onClick={onClick} disabled={disabled}>
      {icon && <Icon name={icon} />}
      {customIcon && <CustomIcon name={customIcon} />}
      {iconElement}
      <span>{label}</span>
    </button>
  )

  if (to)
    return (
      <Link className={styles.link} href={to} target={target}>
        {base}
      </Link>
    )

  return base
}

export default FloatingToolbarGridOption
